import FindLocationDetails from './FindLocationDetails';

export default FindLocationDetails;
